import React, { Component } from "react";

import "./Loading.css";

export default class Loading extends Component {
  render() {
    return <div className="Loading">Loading...</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js